import {ProductSwiper} from '../../../common/ui/ProductSwiper';
import {fetchFavorites} from "../../catalog/infrastructure/CatalogService";

export const FavoriteProducts = () => {
  return (
    <ProductSwiper title={'TUS FAVORITOS'} fetchFn={fetchFavorites} />
  );
};
